import { ProductionFigureThemeSizeConfig } from './types';

const medium: ProductionFigureThemeSizeConfig = {
  productionFigure: {},
};

export default medium;
